import React, { useState } from "react";
import { LeadershipGrid } from "@/components/LeadershipGrid/LeadershipGrid";
import { SectionHeading } from "@/components/SectionHeading/SectionHeading";

export const LeadershipTab = ({ data, linkedin, noGrid }) => {
    const [activeTab, setActiveTab] = useState(1);

    return (
        <div className="hp-container flex flex-col items-start">
            <div className="text-center flex-col lg:flex-row flex gap-5 lg:gap-20 items-center justify-between w-full">
                <SectionHeading
                    heading={data.title}
                    subHeading={data.text}
                    // className="lg:items-start lg:text-left "
                />
                <div className="flex gap-5 w-full lg:w-auto">
                   	{/*  <div
                        className={`${
                            activeTab === 1
                                ? "bg-primary border-primary text-white"
                                : "bg-transparent border-[#242222] text-black"
                        }  py-2.5 px-5 lg:px-12 rounded-[20px] inline-block font-bold text-[14px] lg:text-[16px] xl:text-[18px]  border cursor-pointer w-full lg:w-auto`}
                        onClick={() => {
                            setActiveTab(1);
                        }}
                    >
                        Leadership Team
                    </div> */}
					{/* <div
                        className={`${
                            activeTab === 2
                                ? "bg-primary border-primary text-white"
                                : "bg-transparent border-[#BBBBBB] text-black"
                        }  py-2.5 px-5 lg:px-12 rounded-[20px] inline-block font-bold text-[14px] lg:text-[16px] xl:text-[18px]  border cursor-pointer w-full lg:w-auto`}
                        onClick={() => {
                            setActiveTab(2);
                        }}
                    >
                        Board Of Directors
                    </div> */}
                </div>
            </div>
            <div className="py-12 w-full">
                {activeTab === 1 ? (
                    <LeadershipGrid
                        linkedin={linkedin}
                        noGrid={noGrid}
                        members={data.team}
                    />
                ) : (
                    <LeadershipGrid
                        linkedin={linkedin}
                        noGrid={noGrid}
                        members={data.director}
                    />
                )}
            </div>
        </div>
    );
};
